/*
  <ck-avion>: el avión de papel del boletín. Vive dentro de un <ck-liquido> y se
  mueve con su mismo reloj (ganchos `alPaso` y `encima`), así que se pausa
  cuando el líquido se pausa.
  - Parte el líquido («el humo») al cruzarlo: lo aparta y deja una estela abierta.
  - Solo: vueltas en un ocho ancho que llega a las orillas del panel.
  - Mouse o dedo encima: lo persigue; al irse, regresa al ocho.
  - Escribiendo el correo: se estaciona sobre el botón y da una vuelta por letra.
  - Al suscribirse: despega fuera del panel y luego se manda el formulario.
*/
(() => {
  if (customElements.get('ck-avion')) return;

  class CkAvion extends HTMLElement {
    connectedCallback() {
      const liq = this.closest('ck-liquido');
      if (!liq) return;
      const form = liq.querySelector('form');
      this.v = { x: -80, y: 120, vx: 0, vy: 0, a: 0, h: [] };
      this.foco = false; this.sale = false; this.k = 0;

      if (form) {
        form.addEventListener('focusin', () => { this.foco = true; });
        form.addEventListener('focusout', () => { this.foco = false; });
        form.addEventListener('input', () => {
          this.k++;
          this.classList.remove('gira-a', 'gira-b');
          this.classList.add(this.k % 2 ? 'gira-a' : 'gira-b');
        });
        // Al suscribirse la página se recarga: primero despega, luego se manda.
        form.addEventListener('submit', (e) => {
          if (this.sale || !liq.raf) return;
          e.preventDefault();
          this.sale = true; this.foco = false;
          setTimeout(() => form.submit(), 700);
        });
      }

      liq.alPaso = (dt, t, p) => this.paso(dt, t, p, liq);
      liq.encima = (g) => this.estela(g);
    }

    paso(dt, t, p, liq) {
      const v = this.v, W = liq.W, H = liq.H, f = dt * 60;
      let tx, ty;
      if (this.sale) { tx = W + 240; ty = -200; }
      else if (this.foco) {
        const b = liq.getBoundingClientRect(), r = (liq.querySelector('form button') || liq).getBoundingClientRect();
        tx = r.right - b.left - 16; ty = r.top - b.top - 24 + Math.sin(t * 3) * 5;
      }
      else if (p.live) { tx = p.px; ty = p.py; }
      else { tx = W / 2 + Math.sin(t * .5) * (W / 2 - 50); ty = H * .52 + Math.sin(t) * H * .34; }

      // Resorte hacia el blanco; la nariz apunta hacia donde va
      v.vx = (v.vx + (tx - v.x) * .012 * f) * Math.pow(.9, f);
      v.vy = (v.vy + (ty - v.y) * .012 * f) * Math.pow(.9, f);
      v.x += v.vx * f; v.y += v.vy * f;
      if (Math.hypot(v.vx, v.vy) > .4) {
        let da = Math.atan2(v.vy, v.vx) + .38 - v.a;
        da = Math.atan2(Math.sin(da), Math.cos(da));
        v.a += da * Math.min(1, .15 * f);
      }
      v.h.unshift(v.x, v.y); if (v.h.length > 120) v.h.length = 120;

      // Parte el humo: el hueco es un triángulo con la forma del avión, algo más grande
      // (×1.28), girado con él. Los ríos sólo se apartan un poco alrededor.
      liq.repulsores = [{ x: v.x, y: v.y, R: 70 }];
      const k = this.offsetWidth / 72, co = Math.cos(v.a), si = Math.sin(v.a), cx0 = 38.67, cy0 = 35.33;
      liq.cortes = [{
        tri: [[6, 34], [66, 10], [44, 62]].flatMap(([x, y]) => {
          const dx = (cx0 + (x - cx0) * 1.28 - 36) * k, dy = (cy0 + (y - cy0) * 1.28 - 36) * k;
          return [v.x + dx * co - dy * si, v.y + dx * si + dy * co];
        })
      }];
      const m = this.offsetWidth / 2;
      this.style.transform = 'translate(' + (v.x - m) + 'px,' + (v.y - m) + 'px) rotate(' + v.a + 'rad)';
    }

    // Estela de puntos blancos que se desvanece
    estela(g) {
      const h = this.v.h, n = h.length / 2;
      g.fillStyle = '#FFFFFF';
      for (let i = 6; i < n; i += 4) {
        g.globalAlpha = 1 - i / n;
        g.beginPath(); g.arc(h[i * 2], h[i * 2 + 1], 3.2, 0, 7); g.fill();
      }
      g.globalAlpha = 1;
    }
  }

  customElements.define('ck-avion', CkAvion);
})();
